import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

const state = {
  uiFlags: {
    isFetchingCampaign: false,
    isFetchingTasks: false,
    isSaving: false,
  },
  campaign: null,
  tasks: [],
  events: [],
  scripts: [],
  workers: [],
  fieldSummary: null,
  fieldByCity: [],
  fieldHierarchy: [],
  mediaAssets: [],
  map: null,
  pins: [],
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
